<template>
    <div class="d-flex justify-content-start py-3">
        <v-btn v-if="backRoute && hasBackButton" text color="primary" rounded @click="onBack">
            {{ t('default::button.cancel') }}
        </v-btn>
        <b-confirm
            v-if="id && hasDiscardButton"
            :text="t('default::confirmation.discard_changes')"
            :title="t('default::confirmation.general')"
            @true="onDiscard"
        >
            <template #button="{ on }">
                <v-btn class="ml-4" text rounded color="primary" v-on="on">
                    {{ t('default::button.discard_changes') }}
                </v-btn>
            </template>
        </b-confirm>
        <v-btn
            v-if="hasSaveButton"
            :disabled="isDisabled"
            class="ml-4"
            rounded
            :loading="loading"
            color="primary"
            @click="onSave"
        >
            {{ t('default::button.save') }}
        </v-btn>
        <slot name="buttons"></slot>
    </div>
</template>

<script>
export default {
    props: {
        backRoute: {
            type: String,
            required: false,
            default: null,
        },
        id: {
            type: String,
            required: false,
            default: null,
        },
        hasSaveButton: {
            type: Boolean,
            default: true,
        },
        hasBackButton: {
            type: Boolean,
            default: true,
        },
        hasDiscardButton: {
            type: Boolean,
            default: true,
        },
        isDisabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            loading: false,
        };
    },
    methods: {
        onDiscard() {
            this.$emit('discard');
        },
        onSave() {
            this.$emit('save');
        },
        onBack() {
            window.location = this.backRoute;
        },
    },
};
</script>
